import axios from "axios";
import { apiKey } from "../config/config";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function UserProfile({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [userDetail, setUserDetail] = useState();
  const { user_type, id } = useParams();

  const navigate = useNavigate();

  function convertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    const formattedDate = dateObject.toLocaleDateString("en-GB", options);
    return formattedDate;
  }

  useEffect(() => {
    const api =
      user_type === "guarantor"
        ? `${apiKey}/get-guarantor/${id}`
        : `${apiKey}/get-user/${user_type}/${id}`;
    try {
      axios
        .get(api, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setUserDetail(res.data.result[0]);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [id, token, user_type]);
  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>
          {lang.Investment_Loan_Management || "Investment/Loan Management"}
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <img src="/img/homeicon.png" alt="logo" className="sidebaricon" />
            </li>
            <li className="breadcrumb-item">
              {lang.Customer_Management || "Customer Management"}
            </li>
            <li className="breadcrumb-item active">
              {lang.Customer || "Customer"}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <h4 className="headingh4 fw-bold">
                    {lang.Profile_Information || "Profile Information"}
                  </h4>
                </div>
                <div className="row justify-content-end">
                  <div className="col-md-5 col-lg-3">
                    <button onClick={() => navigate(-1)} type="button" className="btn-save btn">
                      {lang.Back || "Back"}
                    </button>
                  </div>
                </div>
                {userDetail && (
                  <div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Full_Name || "Full Name"}:
                          </span>{" "}
                          {userDetail.FullName}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Identity_Number || "Identity Number"}:
                          </span>{" "}
                          {userDetail.ValidNationalID}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Identity_Number || "Identity Number"}:
                          </span>{" "}
                          {userDetail.ValidNationalID}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Release_Date || "Release Date"}:
                          </span>{" "}
                          {convertDateFormat(userDetail.ReleaseDate)}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Source || "Source"}:
                          </span>{" "}
                          {userDetail.Source}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Date_of_Birth || "Date Of Birth"}:
                          </span>{" "}
                          {convertDateFormat(userDetail.DoB)}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Gender || "Gender"}:{" "}
                          </span>{" "}
                          {userDetail.Gender}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Mobile_Number || "Mobile Number"}:{" "}
                          </span>{" "}
                          {userDetail.MobilePhoneNo}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Email || "Email"}:
                          </span>{" "}
                          {userDetail.Email}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Nationality || "Nationality"}:
                          </span>{" "}
                          {userDetail.Nationality}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Country || "Country"}:
                          </span>{" "}
                          {userDetail.Country}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">{lang.City || ""}:</span>{" "}
                          {userDetail.City}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 ">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Full_Address || "Full Address"}:
                          </span>{" "}
                          {userDetail.Address}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Occupation || "Occupation"}:
                          </span>{" "}
                          {userDetail.Occupation}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3">
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Employer_Name || "Employer Name"}:
                          </span>{" "}
                          {userDetail.EmployerName}
                        </div>
                        <div className="col-sm-4">
                          <span className="fw-bold">
                            {lang.Designation || "Designation"}:
                          </span>{" "}
                          {userDetail.Designation}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="row mb-3 col-d-12">
                        <span className="fw-bold">
                          {lang.Description || "Description"}:
                        </span>{" "}
                        <span> {userDetail.AdditionalNotes}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default UserProfile;
